import type { ResultOf } from '@graphql-typed-document-node/core';

import { getFragmentData, graphql } from '@e-socna/data-layer';
import { EMPTY_ARRAY } from '@e-socna/empty';
import type { FragmentType } from '@e-socna/data-layer';

import { DataGrid } from '../../../components/DataGrid';

import { columns } from './columns';

export const LocalityInfosPage_List_LocalityInfo_Fragment = graphql(`
  fragment LocalityInfosPage_List_LocalityInfo_Fragment on LocalityInfo {
    _id
    locality
    departmentCode
    postalCode
    departmentName
    earthquakeZone
    snowZone
    windZone
    distanceInKm
    altitudeInM
  }
`);

export type LocalityInfosPage_List_LocalityInfo = ResultOf<
  typeof LocalityInfosPage_List_LocalityInfo_Fragment
>;

interface Props {
  readonly isSuccess: boolean;
  readonly localityInfos?: readonly FragmentType<
    typeof LocalityInfosPage_List_LocalityInfo_Fragment
  >[];
}

export const List = ({
  isSuccess,
  localityInfos: pLocalityInfos,
}: Readonly<Props>) => {
  const localityInfos = getFragmentData(
    LocalityInfosPage_List_LocalityInfo_Fragment,
    pLocalityInfos,
  );

  return (
    <DataGrid
      columns={columns}
      loading={!isSuccess}
      rows={localityInfos ?? EMPTY_ARRAY}
    />
  );
};
